import * as React from 'react';
import './expert.scss';
import { Progress, Tooltip, Switch } from 'antd';
import Indices from '../indices/indices';
import { requestPapers, requestAnnotation } from '../../model/api';
import chroma from 'chroma-js';

export default class Expert extends React.Component {
    _colorScale = chroma.scale(['green', 'gold', 'darkviolet']);
    constructor(props) {
        super(props);
        this.state = {
            expand: true,
            pubs: null,
            checked: props.data.anno_info ? props.data.anno_info.data == 1 : true,
            venues_expand: true
        }
        this.handleSwitchChange = this.handleSwitchChange.bind(this);
    }

    componentDidMount() {
        if(this.state.expand) {
            this.requestPubs();
        }
    }

    componentDidUpdate(preProps, preState) {
        if(preProps.data != this.props.data) {
            this.setState({pubs: null, checked: this.props.data.anno_info ? this.props.data.anno_info.data == 1 : true})
        }
        if(preProps.data != this.props.data || !preState.expand && this.state.expand) {
            this.requestPubs();
        }

    }

    requestPubs() {
        let ids = this.props.data.matched_pubs;
        if(ids && ids.length) {
            if(ids.length > 3) ids = ids.slice(0, 3);
            requestPapers(ids).then(data => {
                if(data && data.data && data.data.length && data.data[0].items.length) {
                    this.setState({pubs: data.data[0].items});
                }
            })
        }
    }

    activityText(level) {
        level = level || "low";
        switch(level) {
            case 'low': 
                return <span style={{color: 'mediumseagreen'}}>低</span>;
            case 'mid': 
                return <span style={{color: 'orange'}}>中</span>;
            case 'high': 
                return <span style={{color: 'darkviolet'}}>高</span>;
        }
    }

    formatNum(num) {
        if(num > 100000000) {
            return (Math.floor(num / 1000000) / 100) + '亿';
        }else if(num > 10000) {
            return (Math.floor(num / 100) /100) + '万';
        }else {
            return num.toString();
        }
    }

    costText(range) {
        if(range && range.length && range.length == 2) {
            let min = range[0];
            let max = range[1];
            if(!max) {
                return <span>{`大于 ${this.formatNum(min)}`}</span>
            }else {
                return <span>{`${this.formatNum(min)} - ${this.formatNum(max)}`}</span>
            }
        }
    }

    getLevelColor(level) {
        switch(level) {
            case "A": 
                return 'gold';
            case "B": 
                return "lightsteelblue";
            case "C": 
                return 'red';
            default:
                return "lightgrey";
        }
    }

    handleSwitchChange(checked) {
        let data = checked ? 1 : 0;
        this.setState({checked});
        requestAnnotation(this.props.result_id, this.props.data.id, data).then((d) => {
            if( d && d.status != 0 ) {
                this.setState({checked: !checked});
            }
        })
    }

    render() {
        const { data } = this.props;
        const { expand, pubs, venues_expand } = this.state;
        let name = data.name_zh ? data.name_zh + (data.name ? ` (${data.name})` : "") : data.name;
        const tags = data.tags ? (data.tags.length > 8 ? data.tags.slice(0, 8) : data.tags) : [];
        const isMobile = document.body.offsetWidth < 560;

        const venues_desc = !data.matched_venues ? [] : data.matched_venues.map((d) => {
            return <div className='partner_venues'>该专家在 <b>{d.venues.slice(0, 3).map(v => v.short_name || v.name).join(", ")}</b> 等 <b>{d.venues.length}</b> 个高影响力期刊会议共发表 <b>{d.venues.reduce((total, v) => total += v.pub_num, 0)}</b> 篇  <b>{d.term_zh ? `${d.term_zh}(${d.term})` : d.term}</b> 相关论文。</div>
        })
        return (
            <div className='expert'>
                <div className='up'>
                    <div className='left'>
                        <img src={data.avatar || "https://avatarcdn.aminer.cn/default/default.jpg!160"} />
                    </div>
                    <div className='right'>
                        <div className='name' onClick={() => window.open(`https://www.aminer.cn/profile/${data.id}`, "_blank")}>{name}</div>
                        <div className='info'>
                            <Indices data={data.indices} />
                        </div>
                        { data.profile && (data.profile.position || data.profile.position_zh) && <div className='info'><i className='fas fa-briefcase' /><span className='value'>{(data.profile && (data.profile.position_zh || data.profile.position)) || ""}</span></div> }
                        { data.profile && (data.profile.affiliation || data.profile.affiliation_zh) && <div className='info'><i className='fas fa-university' /><span className='value'>{(data.profile && (data.profile.affiliation_zh || data.profile.affiliation)) || ""}</span></div> }
                        { !!tags.length && (
                            <div className='info tags'>
                                { tags.map((d, i) => <div key={i} className='tag'>{d}</div>)}
                            </div>
                        )}
                    </div>
                    { this.props.dev_mode && (
                        <div className='dev'>
                            <Switch checkedChildren="1" unCheckedChildren="0" checked={this.state.checked} onChange={this.handleSwitchChange} />
                        </div>
                    )}
                </div>
                <div className='down'>
                    <div className='score_bar'>
                        <div className='score_item'>
                            <div className='score_title'>推荐度</div>
                            <Progress
                                className='similar'
                                strokeColor={this._colorScale(data.score || 0).hex()}
                                size={isMobile ? 'small' : 'large'}
                                percent={Math.floor((data.score || 0)*1000)/10}
                                strokeWidth={16}
                            />
                        </div>
                        <div className='score_item'>
                            <div className='score_title'>业界活跃度<Tooltip title='根据最近几年和业界公司的合作历史计算'><span className='tip'>?</span></Tooltip></div>
                            <div className='activity'>{this.activityText(data.industry_activity_level)}</div>
                        </div>
                        {
                            !isMobile && (
                                <div className='score_item'>
                                    <div className='score_title'>学术活跃度<Tooltip title='根据最近几年论文发表情况计算'><span className='tip'>?</span></Tooltip></div>
                                    <div className='activity'>{this.activityText(data.scholarly_activity_level)}</div>
                                </div>
                            )
                        }
                        <div className='score_item'>
                            <div className='score_title'>合作成本(¥)<Tooltip title='算法估算值，仅供参考'><span className='tip'>?</span></Tooltip></div>
                            <div className='activity'>{this.costText(data.cost_range)}</div>
                        </div>
                        {
                            isMobile && (
                                <div className='score_item'>
                                    <div className='score_title'>学术活跃度<Tooltip title='根据最近几年论文发表情况计算'><span className='tip'>?</span></Tooltip></div>
                                    <div className='activity'>{this.activityText(data.scholarly_activity_level)}</div>
                                </div>
                            )
                        }
                    </div>
                    { 
                        data.co_partners && !!data.co_partners.length && (
                            <div className='partners'>
                                <div className='partners_title'>{`业界合作经历 (${data.co_partners.length})`}</div>
                                <div className='partners_list'>
                                    {data.co_partners.map((d, i) => {
                                        return <Tooltip title={d.name} key={i}><div className='partner'>{`${d.name}`}</div></Tooltip>
                                    })}
                                </div>
                            </div>
                        )
                    }
                    {
                        !!venues_desc.length && (
                            <div className='partners'>
                                <div className='partners_title' onClick={() => this.setState({venues_expand: !venues_expand})}>{`相关发表统计`}<i className={`fas fa-chevron-${venues_expand ? "up" : "down"}`} /></div>
                                { venues_expand && (
                                    <div className='partners_list'>
                                        {venues_desc}
                                    </div>
                                )}
                            </div>
                        )
                    }
                    <div className='pubs'>
                        <div className='pubs_title' onClick={() => this.setState({expand: !expand})}>{`代表性研究 (${(pubs && pubs.length) || 0})`}<i className={`fas fa-chevron-${expand ? "up" : "down"}`} /></div>
                        { expand && (
                            <div className='pubs_list'>
                                { pubs && !!pubs.length && pubs.map((d, i) => {
                                    return (
                                        <div key={i} className='paper'>
                                            <div className='title' onClick={() => window.open(`http://aminer.cn/pub/${d.id}`, "_blank")}>{d.title || d.title_zh}</div>
                                            <div className='authors'>{d.authors.map(a => a.name || a.name_zh).join(", ")}</div>
                                            <div className='info'><span>{`[${d.year}]${d.venue && d.venue.info && d.venue.info.name ? ` • ${d.venue.info.name}` : ""}`}</span></div>
                                        </div>
                                    )
                                })}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}